import { ContactSubscriptionItemInterface } from 'modules/contacts/contact-page/types/contact-subscriptions-interface'
import { SubscriptionInterface } from '../types/subscription-interface'

export const checkIsContactsSubscription = (
  subscriptionItems:
    | ContactSubscriptionItemInterface[]
    | SubscriptionInterface['subscriptionItems'],
): subscriptionItems is ContactSubscriptionItemInterface[] =>
  'status' in (subscriptionItems?.[0] ?? {})
